// src/pages/profile/Profile.js
import React from "react";
// import "./profile.css";

export default function Profile() {
  return (
    <div className="profile">
      <h1>Profile Page</h1>
    </div>
  );
}
